export const happyBirthdayMelody = [
  "C", "C", "D", "C", "F", "E",
  "C", "C", "D", "C", "G", "F",
  "C", "C", "C5", "A", "F", "E", "D",
  "A#", "A#", "A", "F", "G", "F"
];
